import { NextPage } from "next";
import { withUrqlClient } from "next-urql";
import { dedupExchange, cacheExchange, fetchExchange } from "urql";
import { devtoolsExchange } from "@urql/devtools";
import { persistedFetchExchange } from "@urql/exchange-persisted-fetch";

export const withData = (Component: NextPage, disableSsr = false) => {
  return withUrqlClient(
    (ssrExchange, ctx) => {
      const exchanges = [
        dedupExchange,
        cacheExchange,
        ssrExchange,
        persistedFetchExchange({ preferGetForPersistedQueries: true }),
        fetchExchange,
      ];

      if (process.env.NODE_ENV === "development") {
        exchanges.unshift(devtoolsExchange);
      }

      return {
        url: process.env.GRAPHQL_API_URL,
        fetchOptions: {
          headers: {
            "x-api-key": process.env.GRAPHQL_API_KEY,

            // Check for the existence of cookies on the SSR request, and forward
            // them if they exist.
            ...(ctx?.req?.headers.cookie
              ? { cookie: ctx?.req?.headers.cookie }
              : {}),
          },
          credentials: "include",
        },
        exchanges,
      };
    },
    { ssr: !disableSsr }
  )(Component);
};

export { useQuery } from "urql";
export { default as gql } from "graphql-tag";
export type { NextUrqlPageContext } from "next-urql";
